// extracted by mini-css-extract-plugin
export default {"ratingInput":"RatingInput_ratingInput__z4om+"};